import styled from 'styled-components';
import { COLORS } from '../../../../utils/constants/styles';

export const PageContainer = styled.div`
  display: flex;
  padding: 28px 42px;
  gap: 16px;
  background-color: ${COLORS.WHITE};
`;
